export default {"src":"/_next/static/media/blog.5c9a2766.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};